<div class="menu-container">
  <!-- Checkbox for CSS-only mobile menu toggle -->
  <input class="menu-toggle" id="menu-toggle" type="checkbox">

  <div class="mobile-bar">
    <span class="phone"><i class="pi pi-phone"></i> 0492-342013</span>
    <div class="right-actions">
      <div class="language-dropdown-container mobile">
        <input class="submenu-checkbox" id="lang-toggle-mobile" style="display: none;" type="checkbox">
        <label class="lang-selected" for="lang-toggle-mobile">
          <p-avatar image="icons/flags/{{ selectedCountry().toLowerCase() }}.svg" shape="circle" styleClass="flag"></p-avatar>
        </label>
        <div class="lang-submenu">
          <ul class="submenu-list">
            @for (lang of languages; track lang.language) {
              <li>
                <div (click)="selectLanguage(lang.language)" class="submenu-link">
                  <img [alt]="lang.language.toLowerCase()" src="icons/flags/{{ lang.language.toLowerCase() }}.svg" style="height: 20px;"/>
                  <span>{{ lang.label }}</span>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
      <label class="hamburger-btn" for="menu-toggle">
        <i class="pi pi-bars"></i>
      </label>
    </div>
  </div>

  <nav class="nav-menu">
    <ul class="root-list">
      @for (item of items(); track item.label) {
        <li class="menu-item">
          @if (item.items) {
            <input class="submenu-checkbox" id="submenu-{{item.label}}" style="display: none;" type="checkbox">
            <label class="item-link" for="submenu-{{item.label}}">
              <span class="item-label">{{ item.label }}</span>
              <i class="pi pi-angle-down submenu-icon"></i>
            </label>
          } @else {
            <a [routerLink]="item.routerLink" class="item-link" (click)="closeMenu()">
              <span class="item-label">{{ item.label }}</span>
            </a>
          }

          @if (item.items) {
            <div class="submenu-panel">
              <div class="submenu-grid">
                @for (col of item.items; track col) {
                  <div class="submenu-column">
                    @for (subItem of col; track subItem.label) {
                      <div class="submenu-section">
                        @if (subItem.items) {
                          <ul class="submenu-list">
                            @for (child of subItem.items; track child.label) {
                              <li>
                                <a [routerLink]="child.routerLink" class="submenu-link" (click)="closeMenu()">
                                  {{ child.label }}
                                </a>
                              </li>
                            }
                          </ul>
                        } @else if (subItem.routerLink) {
                          <a [routerLink]="subItem.routerLink" class="submenu-link single" (click)="closeMenu()">
                            {{ subItem.label }}
                          </a>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </li>
      }

      <!-- Desktop only end items -->
      <li class="desktop-only-end">
        <div class="search-container">
          <div class="search-wrapper" [class.expanded]="searchExpanded()">
            <i class="pi pi-search search-icon" (click)="toggleSearch()"></i>
            <div class="search-input-container">
              <p-iconfield iconPosition="left">
                <p-inputicon>
                  <i class="pi pi-search"></i>
                </p-inputicon>
                <input type="text" pInputText placeholder="Zoeken naar producten..." [ngModel]="searchTerm()" (ngModelChange)="updateSearchTerm($event)" class="search-input" />
                @if (searchTerm()) {
                  <p-inputicon class="clear-icon" (click)="updateSearchTerm('')">
                    <i class="pi pi-times"></i>
                  </p-inputicon>
                }
              </p-iconfield>
            </div>
          </div>
        </div>
        <span class="phone"><i class="pi pi-phone"></i> 0492-342013</span>
        <div class="language-dropdown-container desktop">
          <div class="lang-selected">
            <p-avatar image="icons/flags/{{ selectedCountry().toLowerCase() }}.svg" shape="circle" styleClass="flag"></p-avatar>
          </div>
          <div class="lang-submenu">
            <ul class="submenu-list">
              @for (lang of languages; track lang.language) {
                <li>
                  <div (click)="selectLanguage(lang.language)" class="submenu-link">
                    <img [alt]="lang.language.toLowerCase()" src="icons/flags/{{ lang.language.toLowerCase() }}.svg" style="height: 20px;"/>
                    <span>{{ lang.label }}</span>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</div>
